// 7 is the highest int of a photo's aspect ratio seen so far
const maxAspW = 7;
const maxAspH = 7;

const foundRatios = {};
const aspectRatios = {};
for (let ratioW = 1; ratioW <= maxAspW; ratioW++) {
  for (let ratioH = 1; ratioH <= maxAspH; ratioH++) {

    let ratioX = ratioW / ratioH;

    if (!foundRatios[ratioX]) {
      foundRatios[ratioX] = true;

      aspectRatios[ratioW + ':' + ratioH] = ratioX;
    }
  };
};

export const getLocalizedDate = (locale, date) => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  if (date instanceof Date) {
    return new Intl.DateTimeFormat(locale, { dateStyle: 'full' }).format(date);
  }
  return '';
}

export const getMonth = date => {
  if (!date || !date.getMonth) {
    date = new Date(date);
  }

  let months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  return months[date.getMonth()];
}

export const getMonthAbbr = date => {
  if (!date || !date.getMonth) {
    date = new Date(date);
  }

  let months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]

  return months[date.getMonth()];
}

export const formatDate = date => {
  if (!date || !date.getMonth) {
    date = new Date(date);
  }

  let month = getMonth(date);
  let day = date.getDate();
  let year = date.getFullYear();

  return `${month} ${day}, ${year}`;
}

export const formatShortDate = date => {
  if (!date || !date.getMonth) {
    date = new Date(date);
  }

  let year = date.getFullYear();

  let month = date.getMonth() + 1;
  if (month.toString().length === 1) {
    month = '0' + month;
  }

  let day = date.getDate();
  if (day.toString().length === 1) {
    day = '0' + day;
  }

  return `${year}-${month}-${day}`;
}

export const formatGuestName = guest => {
  let firstName = guest.first_name;
  let lastName = guest.last_name.split(' ').map(n => {
    return n[0] + n.substr(1, n.length).toLowerCase();
  }).join(' ');

  return `${firstName} ${lastName}`;
}

export const findGCF = (a, b) => {
  // Finds the Greatest Common Factor of two numbers
  // Used to determine aspect ratio of images

  if (!a || !b) {
      return 1
  }

  // Ensure positive integers
  a = Math.abs(a);
  b = Math.abs(b);

  // Euclidean algorithm
  while (b !== 0) {
    let temp = b;
    b = a % b;
    a = temp;
  }

  // Return GCF
  return a;
}

export const calculateAspectRatio = (width, height) => {
  const gcf = findGCF(width, height);
  const aspHeight = Math.floor(height / gcf);
  const aspWidth = Math.floor(width / gcf);

  return aspWidth + ":" + aspHeight
}

export const nearestNormalAspectRatio = (width, height) => {
  // Finds the approximate aspect ratio based on supplied width/height
  const ratio = width / height;

  let match;
  for (let key in aspectRatios) {
    if (!match || (
      Math.abs(ratio - aspectRatios[key]) < Math.abs(ratio - aspectRatios[match])
    )) {
      match = key
    }
  }

  return match;
}

export const getAspectRatio = (width, height) => {
  // Wrapper to swap aspect ratio approaches
  return  nearestNormalAspectRatio(width, height);
}
